import tail from 'tail.select';
import { CONFIG } from '../config';
import * as helpers from '../../tools/helpers';

class BfvMultiselect {
  constructor(options = {}) {
    this.$root = options.element;
    this.$select = this.$root.querySelector('select');
    this.$options = this.$select.getElementsByTagName('option');
    this.$tailSelect = null;
    this.$required = false;
    this.$multiselect = this.$root.querySelector('.bfv-multiselect');
  }

  init() {
    try {
      this.$tailSelect = tail(this.$select, {
        bindSourceSelect: true,
        hideSelect: true,
      });

      this.bindOptionClick();
      this.bindResetEvent();
    } catch (errorM) {
      // eslint-disable-next-line
      console.log(errorM);
    }

    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(
      CONFIG.events.BFV_RESET_FILTER,
      false,
      false,
      CONFIG.eventstData.BFV_RESET_FILTER__ALL,
    );
    this.$root.dispatchEvent(event);
  }

  bindOptionClick() {
    const tailOptionArray = Array.prototype.slice.call(this.$root.querySelectorAll('.tail-dropdown-option'));
    tailOptionArray.forEach(($option) => {
      $option.addEventListener('click', () => {

        // eslint-disable-next-line
        let selectedOptions = [];
        [...this.$options].forEach((option) => {
          if (option.selected) {
            selectedOptions.push({
              value: option.value,
              label: option.innerText,
            });
          }
        });

        const $eventTarget = helpers.findParent(this.$select, CONFIG.multiselect.changeListenerClass);

        if ($eventTarget) {
          const event = document.createEvent('CustomEvent');
          event.initCustomEvent(CONFIG.events.BFV_MULTISELECT_CLICKED, false, false, {
            name: this.$select.getAttribute('name'),
            selectedOptions,
          });
          $eventTarget.dispatchEvent(event);
        }
      });
    });
  }

  // noinspection JSMethodCanBeStatic
  triggerOptionClick($option) {
    // eslint-disable-next-line
    $option.selected = false;
  }

  bindResetEvent() {
    this.$root.addEventListener(CONFIG.events.BFV_RESET_FILTER, (event) => {

      if (event.detail.value === 'reset-all') {
        const $options = this.$select.querySelectorAll('option[selected="selected"]');
        Array.prototype.slice.call($options).forEach(($option) => {
          this.triggerOptionClick($option);
        });
      } else {
        const $option = this.$select.querySelector(`option[value="${event.detail.value}"]`);
        this.triggerOptionClick($option);
      }

      const changeEvent = document.createEvent('Event');
      changeEvent.initEvent('change', true, true);
      this.$select.dispatchEvent(changeEvent);
    });
  }
}

export default BfvMultiselect;
